import React from 'react';
import Header from '../components/landing/Header';
import StudentResultsSection from '../components/landing/StudentResultsSection';
import Footer from '../components/landing/Footer';

/**
 * Standalone "Результаты учеников" page.
 * URL: /results — публичная ссылка чисто на секцию результатов.
 * Reuses the same StudentResultsSection component as the landing page.
 * CTA leads to the main pricing on the homepage.
 */
const ResultsPage = () => {
  return (
    <div className="min-h-screen bg-[#08080A]">
      <Header />
      <main className="pt-20">
        <StudentResultsSection
          ctaLabel="Узнать как это сделать"
          ctaOnClick={(e) => { e.preventDefault(); window.location.href = '/#pricing'; }}
        />
      </main>
      <Footer />
    </div>
  );
};

export default ResultsPage;
